import { computed, reactive, ref } from '@nuxtjs/composition-api';
import { CUSTOMER_TYPE } from '~/constants/CheckoutFlow';
export default function useCustomerInfo (appContext) {
  const route = appContext.context.route;
  const code = computed(() => route.query.code)
  const permissionsAccepted = ref(null)
  const permissionHeading = 'Vil du have nyheder, gode råd og tilbud?'
  const permissionText = 'Ja tak til nyheder, gode råd, tilbud og konkurrencer. Jeg giver samtidig samtykke til, at Telmore må kontakte mig via e-mail, telefon og sms med nyheder, gode råd og tilbud inden for mobil-, bredbånds- og underholdningsprodukter. Telmore må gerne bruge oplysninger om mit forbrug til at give anbefalinger og tilbud, der passer til mig. Du kan til enhver tid tilbagekalde dit samtykke. Hvis du ønsker at tilbagekalde dit samtykke, kan du gøre dette under telefonopkaldet eller direkte via et afmeldingslink i e-mailen eller sms en. Telmore behandler personoplysninger om dig. Du kan læse mere herom i vores persondatameddelelse'
  const linkText = ' her'
  const personalDataNotificationLink = 'https://www.telmore.dk/om-telmore/persondatameddelelse'
  const permissionCheckBoxText = 'Ja tak, send mig nyheder, gode råd og tilbud'

  const contactInfo = reactive({
    formValid: false,
    phoneNumber: '',
    email: '',
    emailValid: false
  })

  const privateInfo = reactive({
    valid: true,
    formValid: false,
    name: '',
    street: '',
    houseNumber: '',
    floor: '',
    sideOrDoor: '',
    postalCode: '',
    city: '',
    email: '',
    emailValid: false,
    cpr: '',
    phone: ''
  })

  const businessInfo = reactive({
    valid: true,
    formValid: false,
    billingAddress: {},
    cvr: '',
    cvrValid: false,
    email: '',
    emailValid: false,
    phone: ''
  })

  const menu = ref(CUSTOMER_TYPE.PRIVATE)

  const menuItems = computed(() => {
    return [
      {
        label: 'Privatkunde',
        value: CUSTOMER_TYPE.PRIVATE,
        component: 'tlm-checkout-customer-private-customer',
        context: privateInfo,
        activatedMenu: code.value !== '' && code.value !== undefined
      },
      {
        label: 'Erhvervskunde',
        value: CUSTOMER_TYPE.BUSINESS,
        component: 'tlm-checkout-customer-business',
        context: businessInfo
      }
    ]
  })
  const subscriptionSignUpData = computed(() => {
    if (menu.value === CUSTOMER_TYPE.BUSINESS) {
      return {
        contactPhone: businessInfo.phone,
        emailAddress: businessInfo.email,
        cvrNumber: businessInfo.cvr,
        city: businessInfo.billingAddress.postalDistrict,
        cprNumber: null,
        companyName: businessInfo.billingAddress.companyName,
        zipCode: businessInfo.billingAddress.postalCode,
        streetName: businessInfo.billingAddress.streetName,
        houseNumber: businessInfo.billingAddress.houseNumber,
        companyCustomer: true,
        isSimOnly: false
      }
    } else {
      return {
        contactPhone: privateInfo.phone,
        birthDate: null,
        emailAddress: privateInfo.email,
        cvrNumber: null,
        city: privateInfo.city,
        cprNumber: privateInfo.cpr,
        fullName: privateInfo.name,
        zipCode: privateInfo.postalCode,
        streetName: privateInfo.street,
        houseNumber: privateInfo.houseNumber,
        floor: privateInfo.floor,
        companyCustomer: false,
        isSimOnly: false
      }
    }
  })
  const customerDetails = computed(() => {
    if (menu.value === CUSTOMER_TYPE.PRIVATE) {
      return {
        addressDTO: {
          firstName: privateInfo.name.split(' ').slice(0, -1).join(' '),
          lastName: privateInfo.name.split(' ').slice(-1).join(' '),
          streetName: privateInfo.street,
          houseNumber: privateInfo.houseNumber,
          floor: privateInfo.floor,
          side: privateInfo.sideOrDoor,
          postalCode: privateInfo.postalCode,
          postalDistrict: privateInfo.city
        },
        email: privateInfo.email
      }
    } else {
      return {
        cvrNumber: businessInfo.cvr,
        addressDTO: {
          companyName: businessInfo.billingAddress.company,
          streetName: businessInfo.billingAddress.streetName,
          houseNumber: businessInfo.billingAddress.streetNumber,
          floor: businessInfo.billingAddress.floor,
          side: businessInfo.billingAddress.side,
          postalCode: businessInfo.billingAddress.postalCode,
          postalDistrict: businessInfo.billingAddress.city,
          contactNumber: businessInfo.phone
        },
        email: businessInfo.email
      }
    }
  })

  const osmDTO = ref(null)
  const customerType = ref(null)
  return {
    contactInfo,
    customerDetails,
    subscriptionSignUpData,
    permissionCheckBoxText,
    linkText,
    personalDataNotificationLink,
    permissionHeading,
    permissionText,
    menu,
    menuItems,
    customerType,
    privateInfo,
    businessInfo,
    osmDTO,
    permissionsAccepted
  }
}
